import { createContext } from 'react'

import { action, autorun, computed, makeAutoObservable } from 'mobx'

import { GetUserInfoResponse, GetUserProfileResponse } from '../../api/generated'
import { round100 } from '../../utils/round100'
import { browserStorage, parseStorageJSON } from '../browserStorage'

const initialUserInfo: GetUserInfoResponse = {}
const initialProfile: GetUserProfileResponse = {}

class ProfileStorage {
  profile: GetUserProfileResponse = parseStorageJSON(browserStorage.profile, initialProfile)

  userInfo: GetUserInfoResponse = parseStorageJSON(browserStorage.userInfo, initialUserInfo)

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
    autorun(() => {
      browserStorage.userInfo = JSON.stringify(this.userInfo)
      browserStorage.profile = JSON.stringify(this.profile)
    })
  }

  @action
  clear() {
    this.userInfo = initialUserInfo
    this.profile = initialProfile
  }

  @computed getProfile() {
    return this.profile
  }

  @computed getUserInfo() {
    return this.userInfo
  }

  @action setProfile(data: GetUserProfileResponse) {
    const newProfile = {
      ...data,
      buyerRating: data?.buyerRating ? round100(data.buyerRating) : undefined,
      sellerRating: data?.sellerRating ? round100(data.sellerRating) : undefined,
    }

    this.profile = newProfile
  }

  @action setUserInfo(newUserInfo: GetUserInfoResponse) {
    this.userInfo = newUserInfo
  }
}

export default createContext(new ProfileStorage())
